<template>
    <div v-if="tenant.stripeStatus != 'trialing'">
        <h4><i class="fa-fw m-r-5 fa fa-credit-card"></i> {{ $t('credit_card') }}</h4>
        <div v-pml-block="isLoading">
            <div v-if="hasCard">
                <div class="row">
                    <div class="col-sm-6">
                        <p><img :src="`/static/images/flag-cards/${card.brand}.png`" :alt="card.brand" class="max_h_20 pull-left"> <i class="fa fa-circle f_size_6 m-l-10 m-r-5"></i> **** **** **** {{ card.last4 }}</p>
                    </div>
                </div>
                <div v-if="!showForm">
                    <a href="#" @click.default="showForm = true" class="btn btn-warning">
                        <span class="btn-label">
                            <i class="fa fa-refresh"></i>
                        </span>
                        {{ $t('update_card') }}
                    </a>
                </div>
            </div>
            <div v-else>
                <div v-if="!showForm">
                    <p>{{ $t('no_card_found') }}</p>
                    <a href="#" @click.default="showForm = true" class="btn btn-default">
                        <span class="btn-label">
                           <i class="fa fa-credit-card-alt"></i>
                        </span>
                        {{ $t('add_card') }}
                    </a>
                </div>
            </div>
            <PmlForm :visible="showForm" @cardUpdated="cardUpdated" @closeForm="showForm = false"></PmlForm>
        </div>
    </div>
</template>

<script>
    import Notify from '@/utils/helpers/notify'
    import PmlForm from './Form.vue'
    import { trans } from '@/utils/helpers/translation'
    import { getCreditCard } from '@/services/subscriptions'
    import { isNull } from 'lodash'
    import {mapGetters} from 'vuex'

    export default {
        name: 'CreditCard',
        components: {
            PmlForm
        },
        data () {
            return {
                showForm: false,
                card: false,
                isLoading: false
            }
        },
        computed: {
            hasCard () {
                if (this.card)
                    return !(isNull(this.card.brand) || isNull(this.card.exp_month) || isNull(this.card.exp_year) || isNull(this.card.last4))

                return false
            },
            ...mapGetters({
                'tenant': 'getTenant'
            })
        },
        mounted () {
            this.fetch()
        },
        methods: {
            fetch () {
                this.isLoading = true

                getCreditCard()
                    .then(response => {
                        this.card = response.data
                    })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => {
                        this.isLoading = false
                    })
            },
            cardUpdated (card) {
                this.card = card
            },
            cardRefresh () {
                this.fetch()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/company/components/billing/credit-card/Main.vue